import { buildBrokerListMatcher as buildSharedMatcher, type BrokerListMatcher, type ClientMyBroker } from '@numeo/types-core'

export { MATCHES_NO_BROKER } from '@numeo/types-core'
export type { BrokerListMatcher } from '@numeo/types-core'

/**
 * The board's view of the shared broker-list matcher.
 *
 * The identity rules live in `@numeo/types` because the DRIVER's mobile board is served the same Sylectus feed
 * through loads-ingest and has to hide exactly what this hides — a second implementation is how one surface
 * starts showing what the other blocks.
 *
 * All this adds is the client's own broker shape: a `ClientMyBroker` keeps the shared record's addresses and
 * the project's own update addresses in two fields, and the matcher takes one list.
 */
export const buildBrokerListMatcher = (brokers: ClientMyBroker[]): BrokerListMatcher =>
    buildSharedMatcher(
        brokers.map((broker) => ({
            mcNumber: broker.mcNumber,
            companyName: broker.companyName,
            emails: [...(broker.emails ?? []), ...(broker.additionalUpdateEmails ?? [])],
        }))
    )
